export default __webpack_public_path__ + "feature4c40126.png";